import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const PaymentPrivateRoute = props => {
  const { component, isAuthenticated, ...rest } = props;
  const Component = component;

  return (
    <Route
      {...rest}
      render={routeProps => {
        // Check for 3DS return parameters
        const urlParams = new URLSearchParams(routeProps.location.search);
        const paymentIntent = urlParams.get('payment_intent');
        const clientSecret = urlParams.get('payment_intent_client_secret');
        const has3DSParams = paymentIntent && clientSecret;

        // Check if user has valid token in localStorage
        const hasToken = localStorage.getItem('accessToken');

        // Allow access if:
        // 1. User is fully authenticated, OR
        // 2. User has valid token + this is a 3DS return
        const isAuthorized = isAuthenticated || (hasToken && has3DSParams);

        console.log('🔍 PaymentPrivateRoute Auth Check:', {
          isAuthenticated,
          has3DSParams,
          hasToken: !!hasToken,
          isAuthorized,
          path: routeProps.location.pathname
        });

        return isAuthorized ? <Component {...routeProps} /> : <Redirect to={{ pathname: '/', state: { from: routeProps.location } }} />;
      }}
    />
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(PaymentPrivateRoute);

